import React from 'react';
import { type ImageStyle, StyleSheet } from 'react-native';

import { CloudinaryImage, ORDER_LINE_ITEM_IMAGE_CONFIG } from '@garnish/media';

import { ORDER_LINE_ITEM_IMAGE } from '../../OrderLineItem.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const OrderLineItemImage = (props: OrderLineItemImageProps) => {
  const { size = 'sm', assetUrl, 'aria-label': ariaLabel, isDisabled = false } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const imageStyles = [sizeStyles[size], isDisabled ? styles.unavailable : undefined];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <CloudinaryImage
      baseUrl={assetUrl}
      config={ORDER_LINE_ITEM_IMAGE_CONFIG}
      aria-label={ariaLabel}
      style={imageStyles}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const sizeStyles = StyleSheet.create<Record<OrderLineItemImageVariation, ImageStyle>>({
  // eslint-disable-next-line react-native/no-unused-styles
  sm: {
    width: ORDER_LINE_ITEM_IMAGE.SIZE.SM,
    height: ORDER_LINE_ITEM_IMAGE.SIZE.SM,
  },
  // eslint-disable-next-line react-native/no-unused-styles
  md: {
    width: ORDER_LINE_ITEM_IMAGE.SIZE.MD,
    height: ORDER_LINE_ITEM_IMAGE.SIZE.MD,
  },
});

const styles = StyleSheet.create({
  unavailable: {
    opacity: 0.6,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderLineItemImageProps = {
  assetUrl: string;
  'aria-label'?: string;
  size?: OrderLineItemImageVariation;
  isDisabled?: boolean;
};

type OrderLineItemImageVariation = 'sm' | 'md';
